module.exports = __webpack_public_path__ + "static/nyc-background-8e0aca90d3d7e557becc7e7d8f7dd8ed.jpg";